import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "parcel",
  "use": "parcel-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"parcel\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.2941 9.33333H4L8.23529 4H15.2941V9.33333ZM23.7647 4H16.7059V9.33333H28L23.7647 4ZM4 10.6667H28V28H4V10.6667ZM19.5294 25.3333H25.1765V21.3333H19.5294V25.3333Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol